import React from 'react';
import { useState, useEffect } from 'react';
import { Alert } from '../../services/notiflix.service';
import PayoutService from '../../services/payout.service';
import { ThreeDotsIcon } from '../../components/common/IconProvider';
import { formatDate, formatNumber } from '../../utils/Helper';
import { useTranslation } from 'react-i18next';
const UpcomingPayoutList = ({ id }) => {
  const [upcomingPayoutList, setUpcomingPayoutList] = useState([]);
  useEffect(() => {
    listUpcomingPayouts();
  }, []);

  const { t } = useTranslation('projectDetails');

  const listUpcomingPayouts = async () => {
    try {
      let response = await PayoutService.listUpcomingPayouts(id);
      if (response.status === 'failure') {
        Alert.error(response.message);
        return false;
      }
      setUpcomingPayoutList(response.data);
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };

  return (
    <div className="my-6">
      <div className="border-b-2">
        <h3 className="font-medium ">{t('payout_schedule')} </h3>
      </div>
      <div>
        <div className="w-full max-w-3xl">
          <div className="mt-6">
            {upcomingPayoutList &&
              upcomingPayoutList?.schedules?.length > 0 &&
              upcomingPayoutList?.schedules
                .slice(0, -1)
                .map((payoutDate, index) => {
                  return (
                    <div
                      key={index}
                      className="relative pl-8 sm:pl-8 py-2 group"
                    >
                      <div className="flex flex-col sm:flex-row items-start mb-1 group-last:before:hidden before:absolute before:left-2 sm:before:left-0 before:h-full before:px-px before:bg-[#99D94A] sm:before:ml-[0.5rem] before:self-start before:-translate-x-1/2 before:translate-y-3 after:absolute after:left-2 sm:after:left-0 after:w-2 after:h-2 after:bg-[#99D94A] after:border-2 after:box-content after:border-[#f3f4f6]  dark:after:border-[#293448] after:rounded-full sm:after:ml-[0.5rem] after:-translate-x-1/2 after:translate-y-1.5 after:top-3 before:top-3">
                        <div className="max-w-[250px] w-full text-[#002541] bg-white dark:text-white dark:bg-[#293448] px-4 py-2 rounded-md text-xs">
                          {t('interest_payment')}{' '}
                          {formatDate(payoutDate, 'DD MMM YYYY')}
                        </div>
                      </div>{' '}
                    </div>
                  );
                })}
          </div>

          {upcomingPayoutList && upcomingPayoutList?.schedules?.length > 3 && (
            <div className="relative pl-8 sm:pl-8 group">
              <div className="flex flex-col sm:flex-row items-center after:absolute after:left-2 sm:after:left-0  after:box-content after:border-[#f3f4f6] after:rounded-full  sm:after:ml-[0.5rem] after:-translate-x-1/2 after:translate-y-1.5">
                <div className="text-[#B7B7B7] px-4 font-bold">
                  <ThreeDotsIcon />
                </div>
              </div>
            </div>
          )}
          <div className="relative pl-8 sm:pl-8 py-2 group">
            <div className="flex flex-col sm:flex-row ite ms-start mb-1 group-last:before:hidden before:absolute before:left-2 sm:before:left-0 before:h-full before:px-px before:bg-[#99D94A] sm:before:ml-[0.5rem] before:self-start before:-translate-x-1/2 before:translate-y-3 after:absolute after:left-2 sm:after:left-0 after:w-2 after:h-2 after:bg-[#99D94A] dark:after:border-[#293448] after:border-2 after:box-content after:border-[#f3f4f6] after:rounded-full sm:after:ml-[0.5rem] after:-translate-x-1/2 after:translate-y-1.5 after:top-3 before:top-3">
              <div className="max-w-[250px] w-full text-[#002541] bg-white dark:text-white dark:bg-[#293448] px-4 py-2 rounded-md text-xs">
                {t('repayment')}{' '}
                {formatDate(upcomingPayoutList?.maturity_date, 'DD MMM YYYY')}{' '}
                {upcomingPayoutList?.amount
                  ? `:  ${formatNumber(upcomingPayoutList?.amount)}`
                  : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcomingPayoutList;
